module.exports = {
  assetPrefix: `/about`,
  trailingSlash: `ignore`,
  siteMetadata: {
    baseUrl: `https://crunchyroll.com`,
    url: `https://crunchyroll.com/about`,
    title: `Crunchyroll | About`,
    description: `Crunchyroll is the world’s most popular anime brand, connecting a community of over 60 million registered users and 2.6 million subscribers with 360-degree content experiences.`,
    banner: {
      url: `https://crunchyroll.com/about/default-banner.jpg`,
      width: `1520`,
      height: `795`,
    },
  },
  plugins: [
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `images`,
        path: `${__dirname}/src/images`,
      },
    },
    `gatsby-plugin-emotion`,
    `gatsby-plugin-react-helmet`,
    `gatsby-transformer-sharp`,
    {
      resolve: `gatsby-plugin-sharp`,
      options: {
        defaults: {
          formats: [`auto`, `webp`],
          quality: 80,
        },
      },
    },
    `gatsby-plugin-image`,
  ],
}
